import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Modal } from 'antd'

import { useApi } from 'admin/lib/Api'
import { ResendToQCRModal } from 'admin/lib/InTray/ResendToQCRModal'
import { Matchers } from 'admin/lib/Records'
import { useGlobalShortcut } from 'admin/lib/shortcuts'

export const QcrItem = () => {
  const apiToAssign = useApi()
  const { projectId, recordId } = useParams()
  const [resendWarningModuleOpen, setResendWarningModuleOpen] = useState(false)
  const [resendTemplateInput, setResendTemplateInput] = useState('')

  const showResendWarning = () => {
    setResendWarningModuleOpen(true)
  }

  const handleClickResend = async () => {
    // Close Modal and Disable ResendButton to prevent double click
    setResendWarningModuleOpen(false)

    const selectedRecords = [
      {
        recordId: recordId,
        projectId: projectId
      }
    ]

    const [, , error] = await apiToAssign.resendToQCR(
      selectedRecords,
      resendTemplateInput
    )
    if (error) {
      return Modal.error({
        title: 'Resend Failed',
        content: String(error),
        centered: true
      })
    } else {
      return Modal.info({
        title: 'Record resent to QCR',
        content: (
          <div>
            <p>This record has been resent to QCR to be requeued.</p>
            <p>
              Please wait a few minutes and reload before editing this record.
            </p>
          </div>
        ),
        centered: true
      })
    }
  }

  useGlobalShortcut(Matchers.qcr.resendToQcr, showResendWarning)

  return (
    <>
      <div onClick={showResendWarning}>Resend to QCR</div>
      <ResendToQCRModal
        isOpen={resendWarningModuleOpen}
        onClose={() => setResendWarningModuleOpen(false)}
        onSubmit={handleClickResend}
        resendTemplateInput={resendTemplateInput}
        setResendTemplateInput={setResendTemplateInput}
      />
    </>
  )
}
